import { useTranslation } from 'react-i18next'
import { HelpCircle, Mail, MessageSquareQuote } from 'lucide-react'
import { Button } from '@/components/shadcn/button'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/shadcn/tooltip'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/shadcn/popover'

/** Help & support entry point — currently two mailto shortcuts. */
export function HelpPopover() {
  const { t } = useTranslation('header')

  return (
    <Popover>
      <Tooltip>
        <TooltipTrigger asChild>
          <PopoverTrigger asChild>
            <Button variant="ghost" size="icon" className="h-9 w-9 rounded-full">
              <HelpCircle className="h-5! w-5!" />
            </Button>
          </PopoverTrigger>
        </TooltipTrigger>
        <TooltipContent>{t('help.tooltip')}</TooltipContent>
      </Tooltip>
      <PopoverContent align="end" className="w-68 p-3">
        <div className="space-y-3">
          <div>
            <h4 className="font-semibold text-sm">{t('help.title')}</h4>
            <p className="text-[13px] text-muted-foreground">{t('help.description')}</p>
          </div>
          <div className="grid gap-2">
            {/* <Button variant="outline" size="sm" className="w-full justify-start h-9 gap-2" asChild>
              <a href="" target="_blank" rel="noreferrer">
                <ExternalLink className="h-4 w-4 text-primary" />
                <span className="text-xs">Dokumentation</span>
              </a>
            </Button> */}
            <Button variant="outline" size="sm" className="w-full justify-start h-9 gap-2" asChild>
              <a href="mailto:support@bonisoft.de?subject=Support Anfrage Portal">
                <Mail className="h-4 w-4 text-primary" />
                <span className="text-xs">{t('help.mail')}</span>
              </a>
            </Button>
            <Button variant="outline" size="sm" className="w-full justify-start h-9 gap-2" asChild>
              <a href="mailto:support@bonisoft.de?subject=Support Anfrage Portal">
                <MessageSquareQuote className="h-4 w-4 text-primary" />
                <span className="text-xs">{t('help.feedback')}</span>
              </a>
            </Button>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  )
}
